
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/music",
      function () {
        return require("private-next-pages/[locale]/music/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/music"])
      });
    }
  